import { observer } from 'mobx-react-lite'
import { withPrefix } from 'gatsby'
import React from 'react'
import { useStore } from '../../../../../../hooks/useStore'

const MapCloudsTransition = observer(() => {
    const {uiStore: {home__map__showClouds, home__map__transitionDirection}} = useStore();
    // if (!home__map__showClouds) return null;
    // return null;


    return (
        <div className={`${home__map__transitionDirection} ${home__map__showClouds ? "show" : ""}`}>
            <img className="cloud-1" src={withPrefix('/images/map/clouds-01.webp')} alt="" />
            {/* <img className="cloud-2" src="/images/map/clouds-02.webp" alt="" /> */}

            {/* <img className="cloud-3" src="/images/map/clouds-03.webp" alt="" />  */}
            <img className="cloud-4" src={withPrefix('/images/map/clouds-04.webp')} alt="" />

            <style jsx>{`
                div {
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    z-index: 1;
                    pointer-events: none;
                    overflow: hidden;
                    contain: strict;
                }

                img {
                    position: absolute;
                    z-index: 1;
                    // width: 100%;
                    
                    max-width: none;
                    pointer-events: none;
                    // opacity: 1 !important;
                }


                .cloud-1 {
                    top: 0%;
                    right: -20%;
                    width: 50%;

                    right: 10%;
                    top: 5%;
                }


                .cloud-2 {
                    top: 0%;
                    left: -20%;
                    width: 50%;

                    left: 0%;
                }

                .cloud-3 {
                    bottom: 0%;
                    right: -20%;
                    width: 50%;

                    right: -5%;
                    bottom: 5%;
                }

                .cloud-4 {
                    bottom: 0%;
                    left: -20%;
                    width: 50%;

                    left: -5%;
                    bottom: 3%;
                }

                .cloud-1, .cloud-3 {
                    opacity: 0;
                    transform: translateX(0px);
                    transform:  scale(1);
                    transform-origin: center center;
                }



                .show .cloud-1, .show .cloud-3{
                    opacity: 1;
                    transform:  scale(1.7);
                    transition: opacity .7s ease-in 1.2s, transform 2.4s linear;

                }



                .cloud-2, .cloud-4 {
                    opacity: 0;
                    transform: translateX(0px);
                    transform:  scale(1);
                    transform-origin: center center;
                }


                .show .cloud-2, .show .cloud-4 {
                    opacity: 1;
                    transform:  scale(1.7);
                    transition: opacity .75s ease-in 1.2s, transform 2.4s linear;
                }

            `}</style>
        </div>
    )
})

export default MapCloudsTransition